import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { firebaseAppQP } from 'src/utils/firebaseQP';

const getFirebaseQPDownloadUrl = async (filepath: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const storage = getStorage(firebaseAppQP);
        const storageRef = ref(storage, filepath);
        const url = await getDownloadURL(storageRef);
        resolve(url);
      } catch (e) {
        console.log(' Error download file ', e);
        reject(e);
      }
    })
};

export default getFirebaseQPDownloadUrl;
